<template>
    <div style="line-height: 10px;">
        <img style="height:10px; margin-right: 3px; cursor: pointer" src="../assets/images/arrow-up.png" @click="up()"/>
        <img style="height:10px; cursor: pointer" src="../assets/images/arrow-down.png" @click="down()"/>
    </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { eventBus } from '../main'

export default {
    methods: {
        up() {
            this.$emit('up');
        },
        down() {
            this.$emit('down');
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/SectionArrows.vue